import NotificationsPage from '@/views/notifications/NotificationsPage'

export default function NotificationsScreen() {
  return <NotificationsPage />
}
